module.exports = __webpack_public_path__ + "static/media/closeDrawer.3039317a.svg";